/* eslint-disable react/no-deprecated */
import React from "react"
import ReactDOM from "react-dom"

import ToastContainer from "./v1/"
import ToastV2 from "./v2/"
import ThemeProvider from "shared/components/ThemeProvider"
import theme from "shared/skin"

export const showToast = ({
  message,
  type,
  abortReload = true,
  acceptHtml = false,
  version = "v2",
  delay = 3000
}) => {
  const container = document.getElementById("toast-container")

  const handleClose = () => {
    const toastElement = document.getElementById("toast-container")
    ReactDOM.unmountComponentAtNode(toastElement)
  }

  const handleReload = () => {
    if (abortReload) {
      return
    }

    window.location.reload()
  }

  const componentsTypes = {
    v1: ToastContainer,
    v2: ToastV2
  }

  const Component = componentsTypes[version] || ToastV2

  const toastComponent = (
    <ThemeProvider theme={theme}>
      <Component
        id="MAIN_ARTICLE_TOAST_INFORMATION"
        type={type}
        message={message}
        onClose={handleClose}
        onExit={handleReload}
        acceptHtml={acceptHtml}
        delay={delay}
      />
    </ThemeProvider>
  )
  ReactDOM.render(toastComponent, container)
}



// WEBPACK FOOTER //
// ./src/components/Toast/index.js